@if (data?.title) {
<h2 mat-dialog-title>{{ data?.title }}</h2>
}

<mat-dialog-content>{{ data.content }}</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button [mat-dialog-close]="false">Non</button>
  <button mat-stroked-button [mat-dialog-close]="true">Oui</button>
</mat-dialog-actions>
